import { render, staticRenderFns } from "./WorkHours.vue?vue&type=template&id=2c694021&scoped=true&"
import script from "./WorkHours.vue?vue&type=script&lang=js&"
export * from "./WorkHours.vue?vue&type=script&lang=js&"
import style0 from "./WorkHours.vue?vue&type=style&index=0&id=2c694021&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c694021",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/WorkHours.vue
// module id = null
// module chunks = 